// Shared site footer with corpus attribution.
// Used on every public page.

import { Link } from 'react-router-dom'

const GITHUB_URL =
  'https://github.com/ilprl/NepTam-A-Nepali-Tamang-Parallel-Corpus-and-Baseline-Machine-Translation-Experiments'

export function SiteFooter() {
  return (
    <footer className="border-t border-stone-100 bg-stone-50 px-4 py-6 mt-auto">
      <div className="max-w-5xl mx-auto text-center space-y-2">
        <p className="text-xs text-stone-500">
          Corpus source:{' '}
          <a
            href={GITHUB_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-tamang-700"
          >
            NepTam Nepali–Tamang Parallel Corpus
          </a>
          {' '}· All entries are machine-extracted candidates, not verified.
        </p>
        <p className="text-xs text-stone-400">
          <Link to="/about" className="underline hover:text-stone-600">
            About &amp; Credits
          </Link>
          {' '}·{' '}
          <Link to="/" className="hover:text-stone-600">
            Search
          </Link>
          {' '}·{' '}
          <a href="mailto:info@tamang-dictionary.org" className="underline hover:text-stone-600">
            Get in touch
          </a>
        </p>
      </div>
    </footer>
  )
}
